import { render, staticRenderFns } from "./RecipeEditVue.vue?vue&type=template&id=1b317a72&scoped=true&"
import script from "./RecipeEditVue.vue?vue&type=script&lang=js&"
export * from "./RecipeEditVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b317a72",
  null
  
)

export default component.exports